<template>
  <SolutionPageLayout title="Attendee Experience" section="Outcomes">
    <p>
      Great events feel effortless for attendees: clear information, easy navigation, and moments that feel personal rather than generic.
    </p>
    <p>
      Entegy powers cohesive journeys across web, email, and mobile—so attendees spend less time figuring things out and more time engaging with your content and community.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
